<template>
    <div class="project-register-form col-centered">
        <form @submit.prevent="submitForm" method="POST" accept-charset="UTF-8" novalidate="novalidate">
            <div class="margin-xlg-bottom">
                <div class="row">
                    <div class="form-group text-center">
                        <h5 style="font-weight: 500; padding-bottom: 20px;">Create an Onboard account to get started with your tech amenities</h5>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-6 has-feedback mb-lg-1" :class="{'has-error ': errors.has('firstName')}">
                        <input type="text" class="formr-control" placeholder="First Name" v-model="userInfo.firstName" required />
                        <span v-show="errors.has('firstName')" class="help-block">
                            {{ errors.first("firstName") }}
                        </span>
                    </div>
                    <div class="col-md-6 has-feedback" :class="{'has-error': errors.has('lastName')}">
                        <input type="text" class="formr-control" placeholder="Last Name" v-model="userInfo.lastName" required />
                        <span v-show="errors.has('lastName')" class="help-block">
                            {{ errors.first("lastName") }}
                        </span>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-12">
                        <div :class="{'has-error': errors.has('email')}">
                            <input type="email" class="formr-control" placeholder="Email" v-model="userInfo.email" required />
                            <span v-show="errors.has('email')" class="help-block">
                                {{ errors.first("email") }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-6 mb-lg-1">
                        <div :class="{'has-error': errors.has('password')}">
                            <label for="password" style="position: absolute; right: 28px; top: 17px; cursor: pointer" @click="showPass = !showPass">
                                <i class="fa" :class="showPass ? 'fa-eye-slash' : 'fa-eye'" style="font-size: larger" aria-hidden="true" />
                            </label>
                            <input
                                name="password" :type="showPass ? 'text' : 'password'" id="password" required
                                class="formr-control" placeholder="Create Password"  v-model="userInfo.password"
                            />
                            <span v-show="errors.has('password')" class="help-block" style="margin-bottom: 0;">
                                {{ errors.first("password") }}
                            </span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div :class="{'has-error': errors.has('confirmPassword')}">
                            <label for="password_confirm" style="position: absolute; right: 28px; top: 17px; cursor: pointer" @click="showPassConfirm = !showPassConfirm">
                                <i class="fa" :class="showPassConfirm ? 'fa-eye-slash' : 'fa-eye'" style="font-size: larger" aria-hidden="true" />
                            </label>
                            <input
                                name="password_confirm" :type="showPassConfirm ? 'text' : 'password'" id="password_confirm"
                                class="formr-control" placeholder="Confirm Password" v-model="confirmPassword" required
                            />
                            <span v-show="errors.has('confirmPassword')" class="help-block" style="margin-bottom: 0;">
                                {{ errors.first("confirmPassword") }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row margin-lg-bottom">
                <div class="col-md-12">
                    <div :class="{'has-error checkbox': errors.has('accept')}">
                        <label>
                            <input type="checkbox" id="accept" v-model="userInfo.accept" @change="acceptChange()" required />
                        </label>
                        <span>
                            I accept the
                            <a href="/terms" target="_blank">Terms &amp; Conditions</a>
                            and
                            <a href="/privacy-policy" target="_blank">Privacy Policy</a>.
                        </span>
                        <span v-show="errors.has('accept')" class="help-block" style="text-align: center;">
                            {{ errors.first("accept") }}
                        </span>
                    </div>

<!--                    <div class="margin-sm-bottom">-->
<!--                        <label>-->
<!--                            <input type="checkbox" name="active" value="active" :value="canSendSms" @change="canSendSmsSwitch()" />-->
<!--                        </label>-->
<!--                        <span> Receive amenity notifications via text</span>-->
<!--                    </div>-->

                    <div v-if="canSendSms === true" id="canSMS-feedback">
                        <div :class="{'has-error form-group': errors.has('phone')}">
                            <input type="phone" id="phone" class="formr-control" v-model="userInfo.phone" placeholder="Phone Number" />
                            <div class="margin-xlg-left margin-xlg-right" style="font-size: x-small">
                                By providing your number and checking the box above, you consent to receive automated
                                text messages from Onboard in connection with the services and amenities at {{ projectName }},
                                even if your name appears on the do not call list. Message and data rates may apply.
                            </div>
                            <span v-show="errors.has('phone')" class="help-block">
                                {{ errors.first("phone") }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group text-center">
                    <button v-if="isLoading" class="btn theme-primary" disabled><i class="fa fa-cog fa-spin"></i></button>
                    <button v-else type="submit" class="btn theme-primary">Sign Up</button>
                </div>

                <div class="ob-card-bottom">
                    <p>
                        Already have an Onboard account?
                        <a :href="appUrl + '/login'">Login</a>
                    </p>
                </div>
            </div>
            <div class="row" style="padding-top: 20px;">
                <div class="form-group text-center">
                    <p style="font-size: 10px; font-weight: bold; color: #65727f;">
                        Access provided by &nbsp;<img src="https://img.onboardrs.com/onboard/onboard_logo_gray.png" height="20px" />
                    </p>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Vue from "vue";
import VueToastComponent from "./VueToast";

export default {
    props: {
        projectId: {
            required: true,
            type: String,
        },
        appUrl: {
            required: true,
            type: String,
        },
        projectSlug: {
            required: true,
            type: String,
        },
        projectName: {
            required: true,
            type: String,
        },
        brandSuffix: {
            required: true,
            type: String,
        }
    },
    computed: {},
    data() {
        return {
            isLoading: false,
            confirmPassword: null,
            userInfo: {
                firstName: null,
                lastName: null,
                email: null,
                password: null,
                phone: null,
            },
            accept: false,
            canSendSms: false,
            showPass: false,
            showPassConfirm: false,
            counter: 0,
            toastContent: {
                component: VueToastComponent,
                props: {
                    content: "",
                },
            },
        };
    },
    methods: {
        acceptChange() {
            this.accept = !this.accept;
        },

        canSendSmsSwitch() {
            this.canSendSms = !this.canSendSms;
        },

        submitForm() {
            this.isLoading = true;
            this.errors.clear();
            return this.$validator.validateAll().then((valid) => {
                if (valid) {
                    var queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);
                    const residentId = urlParams.get('resident_id');
                    const unitId = urlParams.get('unit_id');
                    const postData = {
                        firstName: this.userInfo.firstName,
                        lastName: this.userInfo.lastName,
                        email: this.userInfo.email,
                        password: this.userInfo.password,
                        confirmPassword: this.confirmPassword,
                        phone: this.userInfo.phone,
                        accept: this.accept,
                        projectId: this.projectId,
                        canSendSms: this.canSendSms,
                        resident_id: residentId,
                        unit_id: unitId
                    };
                    return axios
                        .post("/" + this.projectSlug + "/register-user", postData)
                        .then((response) => {
                            if (response.data.errors) {
                                for (const [key, value] of Object.entries(response.data.errors)) {
                                    this.errors.add({
                                        field: key,
                                        msg: value[0],
                                    });
                                }
                                this.isLoading = false;
                            }
                            else if (response.data.message) {
                                this.toastContent.props.content = response.data.message;
                                this.$toast(this.toastContent, {position: "top-left", toastClassName: "vue-toast"});
                                this.isLoading = false;
                            }
                            else if (response.data.successful) {
                                this.toastContent.props.content = response.data.successful;
                                this.$toast(this.toastContent, {position: "top-left", toastClassName: "vue-toast"});
                                setTimeout(() => {
                                    window.location.href = this.appUrl + "/" + this.projectSlug + "/user/unitSearch";
                                }, 3000);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            this.$toast("There was an error please contact customer support", {position: "top-left", toastClassName: "vue-toast"});
                            this.isLoading = false;
                        });
                }
            });
        },
    },
};
</script>
